/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    MAP_INVENTORY_FETCHED,
    FETCHING_MAP_INVENTORY_FAILED,
    UPDATE_FILTERED_MAP_INVENTORY,
} from '../constants';

const INITIALSTATE = {
    inventory: [],
    inventoryIsLoaded: false,
    filteredInventory: [],
};

const inventory = (state = INITIALSTATE, action) => {
    switch (action.type) {
        case MAP_INVENTORY_FETCHED:
            return { ...state, inventory: action.inventory, inventoryIsLoaded: true };
        case FETCHING_MAP_INVENTORY_FAILED:
            return {
                ...state,
                inventory: [],
                filteredInventory: [],
                inventoryIsLoaded: true,
            };
        case UPDATE_FILTERED_MAP_INVENTORY:
            return { ...state, filteredInventory: action.filteredInventory };
        default:
            return state;
    }
};

export default inventory;
